import { BehaviorSubject } from "rxjs";

const availablesGenes$ = new BehaviorSubject([]);
function setAvailableGenes(genes) {
  availablesGenes$.next(genes);
}
export default { setAvailableGenes, availablesGenes$ };
